const JSON_HEADERS = { 'Content-Type': 'application/json' }

export const setGuestId = (guestId: string): Promise<Response> =>
  fetch('/api/guest/set', {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ guestId }),
  })

export const clearGuest = (): Promise<Response> =>
  fetch('/api/guest/clear', { method: 'POST' })

export const login = (
  email: string,
  password: string
): Promise<{ clientId: string }> =>
  fetch('/api/auth/login', {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ email, password }),
  }).then((r) => {
    if (!r.ok) throw new Error('login failed')
    return r.json()
  }).then((data) => {
    clearGuest()
    return data
  })

export const logout = (): Promise<Response> =>{
  return fetch('/api/auth/logout', { method: 'POST' })}

export type MeResponse = {
  role: 'client' | 'guest' | 'anonymous'
  clientId: string | null
  guestId: string | null
}

export const me = (): Promise<MeResponse> =>
  fetch('/api/auth/me').then((r) => r.json())

export const register = (data: unknown): Promise<{ clientId: string }> =>
  fetch('/api/auth/register', {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  }).then((r) => {
    if (!r.ok) throw r.json()
    return r.json()
  }).then((data) => {
    clearGuest()
    return data
  })

export const confirmSms = (slug: string): Promise<Response> =>
  fetch(`/api/auth/sms-confirm/${slug}`)
